import {
  audienceAssociationSectionStyle,
  commonDoubleListBoxStyle,
  convertToLocalStyle,
  glyphIconStyle,
  helpbuttonStyle,
  paginationStyle,
  searchboxStyle,
  uiblockerStyle,
  audienceModalStyles,
  audienceExpressionStyle,
  audienceCombinedListStyle,
} from '@bingads-webui-campaign-react/common-styles';

export const getAudiencePickerStyle = (_, { palette }) => ({
  '@global': {
    ...uiblockerStyle({ palette }),
    ...audienceModalStyles({ palette }, { modalWidth: 500 }),
    ...audienceExpressionStyle(),
    ...audienceCombinedListStyle({ palette }),
    '.audience-modal.create-audience': {
      width: 700,
    },
  },
  pickerContainer: {
    '& .audience-association-view': {
      ...audienceAssociationSectionStyle({ palette }, { singleListBoxWidth: 450 }),
      ...commonDoubleListBoxStyle({ palette }),
      ...paginationStyle({ palette }),
      ...searchboxStyle({ palette }),
      ...convertToLocalStyle(glyphIconStyle({ palette })),
      ...convertToLocalStyle(helpbuttonStyle({ palette })),

      '& .create-audience-link-section': {
        marginLeft: 0,
      },

      '& .exclude-audience-link-section': {
        marginLeft: 0,
      },

      '& .ima-reach-ineligible-audience-toggle': {
        marginLeft: 16,
        marginTop: 8,
      },

      '& .association-section, .audience__association, .audience__exclusion': {
        '& .DMP_doublelistbox_section .doubleListBox.layout-columns': {
          width: 920,

          '& .form-group, .layout-columns-element:nth-child(1) .form-group:nth-child(1) .dlb-filter-alignPlaceholder .form-control-feedback': {
            margin: 0,
          },
        },

        '& .row': {
          margin: 0,
        },
      },

      '& .selectable-treeview ul': {
        listStyleType: 'none',
        padding: 0,
      },
    },
  },
});
